<template>
  <b-modal
    :ref="(curWidget) ? 'editPivotTableModal' : 'addPivotTableModal'"
    hide-footer
    centered
    :title="(curWidget) ? 'Update Pivot Table widget' : 'Create Pivot Table widget'"
    >
    <b-form @submit.prevent="submit" novalidate>
      <b-form-group label="Name:">
        <b-form-input
          v-model="$v.name.$model"
          :class="{ 'is-invalid': $v.name.$error }"
          type="text"
          /> 
        <b-form-invalid-feedback v-if="!$v.name.required">Name must be provided</b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="$v.name.required && !$v.name.unique">Name must be unique</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Data:">
        <b-form-select
          v-model="$v.dataProvider.$model"
          :class="{ 'is-invalid': $v.dataProvider.$error }"
          :options="dataProviderOptions"
        />
        <b-form-invalid-feedback v-if="!$v.dataProvider.required">Data must be provided</b-form-invalid-feedback>
      </b-form-group>
      <b-button
        v-if="curWidget"
        type="submit"
        :disabled="inProgress"
        >
        Update
      </b-button>
      <b-button
        v-else
        type="submit"
        :disabled="inProgress"
        >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
// services
import db from '@/services/db'
// helpers
import * as eventsBusHolder from '@/helpers/events-bus-holder'
import { required } from "vuelidate/lib/validators";

export default {
  props: ['curWidget'],
  data () {
    return {
      dataProvider: '',
      name: '',
      dataProviderOptions: [],
      inProgress: false,
      allPivotNames: new Set(),
      eventsHolder: eventsBusHolder.createHolder(),
      gsOptions: {}
    }
  },
  computed: {
    ...mapState([
      'currentTab',
      'currentSubTab',
      'dataGrid_options',
      'pivotGridOptions'
    ])
  },
  methods: {
    fillData () {
      const {name = '', dataProvider = ''} = this.pivotGridOptions[this.curWidget] || {};
      this.dataProvider = dataProvider;
      this.name = name;
      this.dataProviderOptions = Object.keys(this.dataGrid_options || {});

      this.allPivotNames.clear();
      const pivots = this.pivotGridOptions || {};
      for (let id in pivots) {
        if (name !== pivots[id].name) {
          this.allPivotNames.add(pivots[id].name);
        }
      }
    },
    submit () {
      this.$v.$touch()
      if (this.$v.$invalid || this.inProgress) return
      this.inProgress = true

      let data = {
        dataProvider: this.dataProvider,
        name: this.name,
        tab: this.currentTab,
        subtab: this.currentSubTab,
        gsOptions: this.gsOptions
      }

      if (this.curWidget) data.table = this.curWidget;

      let createCallback = (curWidget) => {
        this.updateStorePivotGridOptions(curWidget);
        this.$store.commit('addedWidgetKey', curWidget);
        this.gsOptions = {};
        this.$store.commit('deleteProcess', 'createPivot')
        this.inProgress = false
        this.$nextTick(() => {
          if (this.$refs.addPivotTableModal) this.$refs.addPivotTableModal.hide()
          this.$v.$reset()
        })
      }

      let updateCallback = () => {
        this.updateStorePivotGridOptions(this.curWidget);
        this.$store.commit('deleteProcess', 'updatePivot')
        this.$nextTick(() => {
          if (this.$refs.editPivotTableModal) this.$refs.editPivotTableModal.hide()
          this.$v.$reset()
        })
        this.inProgress = false
      }

      if (this.curWidget) {
        this.$store.commit('addProcess', {
          process: 'updatePivot',
          message: 'Updating'
        })
        db.pivotTable.update(data, updateCallback)
      } else {
        this.$store.commit('addProcess', {
          process: 'createPivot',
          message: 'Creating'
        })
        db.pivotTable.create(data, createCallback)
      }
    },
    updateStorePivotGridOptions(curWidget) {
      const pivotItem = {
        [curWidget]: {
          dataProvider: this.dataProvider,
          name: this.name,
          options: '{}'
        }
      };
      this.$store.commit("setPivotGridOptions", {...this.pivotGridOptions, ...pivotItem});
    }
  },
  created () {
    this.eventsHolder.$on('showAddPivotTableModal', ({ gsOptions }) => {
      this.gsOptions = gsOptions;
      if (this.$refs.addPivotTableModal) {
        this.fillData()
        this.$refs.addPivotTableModal.show()
      }
    })
    this.eventsHolder.$on('showEditPivotTableModal', () => {
      if (this.$refs.editPivotTableModal) {
        this.fillData()
        this.$refs.editPivotTableModal.show()
      }
    })
  },
  validations: {
    dataProvider: {
      required
    }, 
    name: {
      required,
      unique(name) {
        return !this.allPivotNames.has(name);
      }
    }
  },
  mounted () {
    if (this.$refs.addPivotTableModal) {
      $(this.$refs.addPivotTableModal['$el']).appendTo('body')
    }
    if (this.$refs.editPivotTableModal) {
      $(this.$refs.editPivotTableModal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    this.eventsHolder.clear()

    if (this.$refs.addPivotTableModal) {
      $(this.$refs.addPivotTableModal['$el']).remove()
    }
    if (this.$refs.editPivotTableModal) {
      $(this.$refs.editPivotTableModal['$el']).remove()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~$scss/globals';

.pivotTableData {
  @include cf;
  &__item {
    @include span(4);
  }
}
</style>
